import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { IMG } from "@/lib/images";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-stone-300 mt-24 relative overflow-hidden"
    >
      <div className="absolute -top-px left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#E10600] to-transparent opacity-70" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="mb-6">
            <img
              src={IMG.logo}
              alt="Linea Bodendesign"
              className="h-20 w-auto object-contain"
              style={{ filter: "url(#brand-light)" }}
            />
          </div>
          <p className="text-sm leading-relaxed text-stone-400 max-w-md">
            Hochwertige, fugenlose Steinteppich-Bodenlösungen für Balkone,
            Terrassen, Treppen und Innenbereiche. Premium-Handwerk mit
            individueller Planung.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-4">
            Navigation
          </div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-white" data-testid="footer-link-home">Start</Link></li>
            <li><Link to="/leistungen" className="hover:text-white" data-testid="footer-link-leistungen">Steinteppich</Link></li>
            <li><Link to="/pu-designboden" className="hover:text-white" data-testid="footer-link-pu">PU Designboden</Link></li>
            <li><Link to="/projekte" className="hover:text-white" data-testid="footer-link-projekte">Projekte</Link></li>
            <li><Link to="/kontakt" className="hover:text-white" data-testid="footer-link-kontakt">Kontakt</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-4">
            Kontakt
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><Phone size={15} className="mt-0.5 shrink-0" /><a href="tel:+491711584130" className="hover:text-white" data-testid="footer-phone">+49 171 158 41 30</a></li>
            <li className="flex items-start gap-3"><Mail size={15} className="mt-0.5 shrink-0" /><a href="mailto:info@linea-boden-design.de" className="hover:text-white" data-testid="footer-email">info@linea-boden-design.de</a></li>
            <li className="flex items-start gap-3"><MapPin size={15} className="mt-0.5 shrink-0" /><span data-testid="footer-address">Weserstr. 133<br/>32457 Porta Westfalica</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-stone-500">
          <div>© {new Date().getFullYear()} Linea Bodendesign. Alle Rechte vorbehalten.</div>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-stone-300" data-testid="footer-link-impressum">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-stone-300" data-testid="footer-link-datenschutz">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
